import * as React from "react";
const SvgChevronDownLightGreen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 9, viewBox: "0 0 14 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 1L7 7L1 1", strokeWidth: 2, stroke: "#597380" }));
export { SvgChevronDownLightGreen as ReactComponent };
